"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
const FacebookShareButton = _ref => {
  let href = _ref.href,
    intl = _ref.intl;
  const handleClick = () => {
    window.open("http://www.facebook.com/sharer.php?u=".concat(href), intl.formatMessage({
      id: 'share.components--facebook-share-button.text',
      defaultMessage: 'Compartilhar no Facebook'
    }), 'width=800,height=600');
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "btn white h3 p3 col-12 caps h5 rounded",
    onClick: handleClick,
    style: {
      backgroundColor: '#2D88ED'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "share.components--facebook-share-button.text",
    defaultMessage: "Compartilhar no Facebook"
  }));
};
var _default = exports.default = (0, _reactIntl.injectIntl)(FacebookShareButton);